import { flattenWithPrefix } from '../utils';
import common from './pages/common';
import admin from './pages/admin';
import searchTable from './pages/searchTable';
import crossborder from './pages/crossborder';

export default {
  ...flattenWithPrefix(common, 'pages'),
  ...flattenWithPrefix(admin, 'pages.admin'),
  ...flattenWithPrefix(searchTable, 'pages.searchTable'),
  ...flattenWithPrefix(crossborder, 'pages.crossborder'),
};
